import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useHotjarRouteTracking = () => {
    const location = useLocation();

    useEffect(() => {
        if (import.meta.env.VITE_APP_ENV === 'production' && window.hj) {
            window.hj('stateChange', location.pathname);
        }
    }, [location]);
};

export default useHotjarRouteTracking;
